(function ($) {

   $(document).ready(function () {

      $('.is-style-swipergallery').each(function () {

         const gallerySlider = $(this);

         let slidesPerView = parseInt( gallerySlider.data('slidesperview') );

         if (isNaN(slidesPerView) || slidesPerView < 1) {
            slidesPerView = 1;
         }

         let controls = Boolean(gallerySlider.data('controls'));

         if(!controls) {
            $(".swiper-button-next", gallerySlider).hide();
            $(".swiper-button-prev", gallerySlider).hide();
         }

         let pagination = Boolean(gallerySlider.data('pagination'));

         if(!pagination) {
            $(".swiper-pagination", gallerySlider).hide();
         }


         let delay = parseInt(
            gallerySlider.data('delay')
         );
         if (isNaN(delay) || delay < 0) {
            delay = 3; // seconds
         }

         new Swiper(gallerySlider[0], {

            direction: 'horizontal',

            loop: true,
            speed: 800,

            slidesPerView: "auto",

            spaceBetween: 20,

            a11y: {
               scrollOnFocus: false,
            },

            autoplay: {
               delay: (delay * 1000),
               disableOnInteraction: false,
            },



            navigation: {
               nextEl: gallerySlider.find('.swiper-button-next')[0],
               prevEl: gallerySlider.find('.swiper-button-prev')[0],
               addIcons: false
            },

            pagination: {
               el: gallerySlider.find('.swiper-pagination')[0],
               clickable: true,
            }

         });

         $(".swiper-wrapper", gallerySlider).wrap('<div class="swiper-wrapper-wrapper"></div>');

         $(".swiper-button-next", gallerySlider).appendTo($(".swiper-wrapper-wrapper", gallerySlider));
         $(".swiper-button-prev", gallerySlider).appendTo($(".swiper-wrapper-wrapper", gallerySlider));


      });

   });

})(jQuery);
